import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Builder from "@/pages/Builder";
import MyBouquets from "@/pages/MyBouquets";
import Orders from "@/pages/Orders";
import SharedBouquet from "@/pages/SharedBouquet";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/studio" element={<Builder />} />
      <Route path="/my-bouquets" element={<MyBouquets />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/b/:shareId" element={<SharedBouquet />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
